import { render } from "./WizardStep3TableDetails.pug?vue&type=template&id=d4eb5306&lang=pug"
import script from "./WizardStep3TableDetails.js?vue&type=script&lang=js"
export * from "./WizardStep3TableDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__